'use strict';

module.exports = function dd() {
  this.dump();

  if (typeof process !== 'undefined') {
    process.exit(1);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/dd.js
// module id = 1643
// module chunks = 2